/* SOLE 2026 — Treadmills collection behavior. Ported from the mockup generator.
   Data emitted by the section as <script id="tc-data" type="application/json">.
   Functions stay global (markup uses inline onclick, matching the QA'd mockup). */
var _TC={}; try{ _TC=JSON.parse((document.getElementById('tc-data')||{}).textContent||'{}'); }catch(e){}
var GOALMAP=_TC.goalmap||{}; var CMPDATA=_TC.cmp||{rows:[],models:{}};
/* Per-category role arrays come from #tc-data; each falls back to the treadmill literal so the treadmills
   collection behaves byte-identically (its #tc-data omits these keys). Ellipticals supply their own. */
/* These literals ARE the live treadmill values, not dead fallbacks: the treadmill #tc-data payload supplies
   only goalmap, cmp, drawer and featured, so best/fold/winnerCodes are read from here on every page load.
   F89 removed 2026-09-16 (product archived, /products/sole-f89 404s). FEATURED reordered 2026-09-18 to the
   price ladder in the section's cfg_order — the two had disagreed since the F80 was promoted on 2026-09-03,
   which made Sort -> "Featured" re-lay the grid in a stale order. Keep them in step. */
var FEATURED=_TC.featured||["F63","F65","F80","F83","F85","C80","TT8"];
/* BEST = the "Best sellers" sort order. Resynced 2026-09-18 to MEASURED units, GA4 property 311077139,
   45 days 2026-08-05..2026-09-18, each model's "w/ Protection" line item merged back into its base (GA4
   splits the warranty attach into a separate product, so raw exports undercount every machine):
     F63 149 | F83 137 | F80 52 | TT8 18 | F65 16 | F85 11 | C80 11
   F85 and C80 tie on units; F85 leads on revenue ($24.9k vs $24.4k), so it sorts first. The previous order
   had F85 fourth on no evidence. Re-measure before trusting this: half the lineup was out of stock for part
   of that window, so units are confounded by availability (F85 had 3 selling days, F80 15). */
var BEST=_TC.best||["F63","F83","F80","TT8","F65","F85","C80"];
var FOLD=_TC.fold||{Foldable:['F80','F85','F83','F63','F65'],'Non-folding':['TT8','C80']};
/* Relaxed-filter spotlight: what lights up when a filter combination matches nothing. It used to be the
   in-stock lead row, which no longer exists, and it pointed at the archived F89 — un-dimming a card that is
   not on the page. In-stock models only, cheapest first. */
var WINNER=_TC.winnerCodes||["F63","F65","F80"];
var ITEMNOUN=_TC.itemNoun||"treadmill";
/* Treadmills only in practice — the ellipticals supply their own copy.relaxedMsg. Deliberately states no
   COUNT and makes no sales claim: it said "our two best-sellers" while WINNER held three codes, and two of
   the models it lights (F65 launched 2026-09-06) have no sales history to call them best-sellers with. */
var RELAXED_MSG=(_TC.copy&&_TC.copy.relaxedMsg)||'<b>No exact match for that combination</b> — showing a few in-stock models to start from. Adjust the filters, or browse the full lineup below.';
var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
function smoothTo(el){ if(el) el.scrollIntoView({behavior: RM?'auto':'smooth'}); }
function _items(){return Array.from(document.querySelectorAll('.tc-item'));}
/* A coming-soon teaser tile, not a buyable product card. Detected structurally (the tile snippet is the
   only thing that emits .tc-cs-card) rather than by model code — the previous version hardcoded 'F83',
   which went stale the moment the F83 shipped on 2026-08-14 and would have to be re-edited at every launch. */
function _isTeaser(el){ return !!(el && el.querySelector && el.querySelector('.tc-cs-card')); }
var activeUC=new Set(), activeBand=new Set();
/* Model-year filter. A boolean rather than a Set because there is only ever one current model year -
   `settings.new_model_year` is a single value, so a card is a current-year model or it is not. */
var activeNew=false;
function _match(el){
  var ucs=(el.getAttribute('data-uc')||'').split(' ');
  var band=el.getAttribute('data-band')||'';
  var matchUC = !activeUC.size || ucs.some(function(u){return activeUC.has(u);});
  /* A teaser with no price band is exempt from the budget filter — it can't be excluded on a price it
     doesn't have. A teaser that DOES carry a band (the F65 is b1) filters like any other card. */
  var matchBand = !activeBand.size || activeBand.has(band) || (!band && _isTeaser(el));
  /* Same exemption as the band above, for the same reason: a coming-soon teaser carries no data-new
     because it does not render through sole-tc-card, and a machine that has not shipped yet is a new
     model by definition. Excluding it on a flag it cannot carry would be the wrong answer. */
  var matchNew = !activeNew || el.getAttribute('data-new')==='1' || _isTeaser(el);
  return matchUC && matchBand && matchNew;
}
function apply(){
  var why=document.getElementById('whyLine'); var any=activeUC.size||activeBand.size||activeNew;
  var items=_items();
  var lit=items.filter(_match).map(function(el){return el.getAttribute('data-code');});
  var teaserCodes=items.filter(_isTeaser).map(function(el){return el.getAttribute('data-code');});
  /* DISTINCT models, not matching elements. A model can render more than once on the page — the treadmills
     featured band repeats F63/F83/F85 above the grid — and counting elements made the status line claim
     "6 models match" for four distinct machines. Dimming below still walks every element; only the COUNT
     the shopper reads is deduped. */
  var buyableLit=lit.filter(function(c,i){return teaserCodes.indexOf(c)<0 && lit.indexOf(c)===i;});
  var relaxed = any && buyableLit.length===0;   // dead-end guard: never dim ALL buyable cards
  items.forEach(function(el){
    var code=el.getAttribute('data-code');
    var on = lit.indexOf(code)>=0;
    if(relaxed) on = WINNER.indexOf(code)>=0; // fall back to the proven winners + new arrival
    el.classList.toggle('dim', any && !on);
  });
  var cb=document.getElementById('clearBtn'); if(cb) cb.classList.toggle('on', !!any);
  if(why){
    if(any){
      why.classList.add('on');
      if(relaxed){ why.innerHTML=RELAXED_MSG; }
      else { var labels=[]; document.querySelectorAll('.chip[aria-pressed=true]').forEach(function(c){labels.push(c.textContent.trim());});
        why.innerHTML='<b>'+buyableLit.length+' model'+(buyableLit.length===1?'':'s')+' match:</b> '+labels.join(' · ')+' — highlighted; others dimmed (nothing hidden).'; }
    } else { why.classList.remove('on'); }
  }
}
function toggleChip(b){var k=b.getAttribute('data-uc');var p=b.getAttribute('aria-pressed')==='true';b.setAttribute('aria-pressed',!p);if(p)activeUC.delete(k);else activeUC.add(k);apply();}
function toggleBand(b){var k=b.getAttribute('data-band');var p=b.getAttribute('aria-pressed')==='true';b.setAttribute('aria-pressed',!p);if(p)activeBand.delete(k);else activeBand.add(k);apply();}
function toggleNew(b){var p=b.getAttribute('aria-pressed')==='true';b.setAttribute('aria-pressed',!p);activeNew=!p;apply();}
function clearFilters(){activeUC.clear();activeBand.clear();activeNew=false;document.querySelectorAll('.chip[aria-pressed=true]').forEach(function(c){c.setAttribute('aria-pressed','false');});apply();}
/* Accessories: single-select compatible-machine filter. Each card carries data-compat ("universal" or
   space-separated families); a card shows when no filter is set, when it's universal, or when its compat
   contains the chosen family. No-op on pages without #accGrid (other collections never call these). */
function _applyAcc(fam){
  var grid=document.getElementById('accGrid'); if(!grid)return;
  var cards=grid.querySelectorAll('.tc-item'), shown=0;
  cards.forEach(function(card){
    var compat=card.getAttribute('data-compat')||'';
    var match=!fam || compat.indexOf('universal')>=0 || compat.indexOf(fam)>=0;
    card.style.display=match?'':'none'; if(match)shown++;
  });
  var lab=document.getElementById('accCount');
  if(lab){ var fb=document.querySelector('.accfilter .chip[data-fam="'+fam+'"]'); var name=fb?fb.textContent.trim().toLowerCase():fam;
    lab.textContent = fam ? (shown+' of '+cards.length+' fit '+name) : ''; }
}
function filterAccessories(btn){
  var was=btn.getAttribute('aria-pressed')==='true';
  document.querySelectorAll('.accfilter .chip').forEach(function(c){c.setAttribute('aria-pressed','false');});
  if(was){ _applyAcc(null); return; } // clicking the active chip clears it
  btn.setAttribute('aria-pressed','true'); _applyAcc(btn.getAttribute('data-fam'));
}
function clearAccFilter(){ document.querySelectorAll('.accfilter .chip').forEach(function(c){c.setAttribute('aria-pressed','false');}); _applyAcc(null); }
function _price(el){var t=el.querySelector('.now');if(!t)return 1e12;return parseFloat(t.textContent.replace(/[^0-9.]/g,''))||1e12;}
/* Best Deals: savings = compare_at (.was) − price (.now); sort the deals grid biggest-savings-first on load. */
function _savings(el){var n=el.querySelector('.now'),w=el.querySelector('.was');if(!n||!w)return 0;var np=parseFloat(n.textContent.replace(/[^0-9.]/g,''))||0,wp=parseFloat(w.textContent.replace(/[^0-9.]/g,''))||0;return wp-np;}
(function(){var g=document.querySelector('[data-deals]');if(!g)return;Array.prototype.slice.call(g.children).sort(function(a,b){return _savings(b)-_savings(a);}).forEach(function(it){g.appendChild(it);});})();
// Concept A pins F80/F85 in a separate hero tier above the sortable grid. For a real sort (price/best) that
// pinning makes "price: low→high" lie (heroes stay on top). So when the sort isn't Featured, fold the heroes
// into the unified grid and sort everything together; restore the hero tier on Featured.
function reflowConceptA(mode){
  var heroGrid=document.getElementById('heroGrid'), restGrid=document.getElementById('restGrid'), heroLabel=document.getElementById('heroLabel');
  if(!heroGrid||!restGrid)return; // not concept A
  if(mode!=='featured'){
    Array.from(heroGrid.children).forEach(function(c){ c.classList.remove('tc-card--hero'); restGrid.appendChild(c); });
    heroGrid.style.display='none'; if(heroLabel) heroLabel.style.display='none';
  } else {
    Array.from(restGrid.querySelectorAll('.tc-card--seller')).forEach(function(c){ c.classList.add('tc-card--hero'); heroGrid.appendChild(c); });
    Array.from(heroGrid.children).sort(function(a,b){ return FEATURED.indexOf(a.getAttribute('data-code'))-FEATURED.indexOf(b.getAttribute('data-code')); }).forEach(function(c){ heroGrid.appendChild(c); });
    heroGrid.style.display=''; if(heroLabel) heroLabel.style.display='';
  }
}
function sortGrid(mode){
  reflowConceptA(mode);
  var grids=document.querySelectorAll('[data-sortable]');
  grids.forEach(function(grid){
    var items=Array.from(grid.children);
    items.sort(function(a,b){
      if(mode==='plh')return _price(a)-_price(b);
      if(mode==='phl')return _price(b)-_price(a);
      var order=(mode==='best')?BEST:FEATURED;
      return order.indexOf(a.getAttribute('data-code'))-order.indexOf(b.getAttribute('data-code'));
    });
    items.forEach(function(it){grid.appendChild(it);});
  });
  var note=document.getElementById('sortNote');
  if(note) note.textContent = (mode==='featured') ? '' : 'Sorted across all models';
}
/* finder (Concept B) */
var fstep=0, fmax=0, fbusy=false, fans={goal:null,fold:null,budget:null};
function fselect(btn,key,val){
  var p=btn.parentNode; p.querySelectorAll('.fopt').forEach(function(o){o.classList.remove('sel');o.setAttribute('aria-pressed','false');});
  btn.classList.add('sel'); btn.setAttribute('aria-pressed','true'); fans[key]=val;
  var nx=document.getElementById('fnext'); if(nx)nx.removeAttribute('disabled');
  // Auto-advance single-select steps (UX panel): on the furthest step, advancing is the only possible action,
  // so do it for the user — EXCEPT the last step, which keeps an explicit "See results" tap (never dump them
  // into the results render on a stray tap). Not on a revisited step (fstep<fmax). 280ms lets the ✓ paint;
  // debounced so a double-click can't queue two advances.
  var steps=document.querySelectorAll('.fstep');
  if(!fbusy && fstep===fmax && fstep < steps.length-1){
    fbusy=true; setTimeout(function(){ fbusy=false; fgo(1); }, 280);
  }
}
function fgo(dir){
  var steps=document.querySelectorAll('.fstep'); var res=document.getElementById('fresult');
  fstep+=dir; if(fstep<0)fstep=0;
  if(fstep>=steps.length){ fshow(); return; }
  if(fstep>fmax)fmax=fstep;
  steps.forEach(function(s,i){s.classList.toggle('on',i===fstep);});
  if(res)res.classList.remove('on');
  document.querySelectorAll('.finder .dots i').forEach(function(d,i){d.classList.toggle('on',i===fstep);});
  var nx=document.getElementById('fnext'); var keys=['goal','fold','budget'];
  if(nx){ if(fans[keys[fstep]])nx.removeAttribute('disabled'); else nx.setAttribute('disabled','');
    nx.textContent = fstep===steps.length-1?'See results':'Next'; }
  // a11y (UX panel): move focus to the new question heading + announce "Step N of M" — fixes the prior
  // focus-drops-to-<body> bug, which auto-advance would otherwise worsen (silent content swap).
  var h=steps[fstep].querySelector('h2');
  if(h){ h.setAttribute('tabindex','-1'); h.setAttribute('aria-label','Step '+(fstep+1)+' of '+steps.length+' — '+(h.textContent||'').trim()); h.focus({preventScroll:true}); }
}
var GOAL_LABEL={walk:'Walking & jogging',run:'Serious running',studio:'Studio / HIIT',low:'Low-impact',comm:'Commercial-grade'};
function _bandOf(code){var el=document.querySelector('.tc-item[data-code="'+code+'"]');return el?el.getAttribute('data-band'):null;}
function fshow(){
  document.querySelectorAll('.fstep').forEach(function(s){s.classList.remove('on');});
  var res=document.getElementById('fresult'); res.classList.add('on');
  // SOFT scoring (no more dead-ends): goal sets the candidate pool; fold + budget RANK (not exclude), so
  // every journey returns real, goal-relevant recommendations — exact matches first, closest fits after.
  var pool=(GOALMAP[fans.goal]&&GOALMAP[fans.goal].length)?GOALMAP[fans.goal].slice():FEATURED.slice();
  /* Coming-soon teasers have no price or buy path, so the finder must never recommend one. Derived from
     the DOM (see _isTeaser) instead of a hardcoded model list, so a launch needs no edit here. */
  pool=pool.filter(function(c){var el=document.querySelector('.tc-item[data-code="'+c+'"]');return !_isTeaser(el);});
  var foldSet=fans.fold?new Set(FOLD[fans.fold]||[]):null;
  var scored=pool.map(function(code){
    var s=0, foldOk=!foldSet, budgetOk=!fans.budget;
    if(foldSet){ foldOk=foldSet.has(code); if(foldOk)s+=2; }
    if(fans.budget){ budgetOk=(_bandOf(code)===fans.budget); if(budgetOk)s+=2; }
    return {code:code,score:s,foldOk:foldOk,budgetOk:budgetOk,exact:foldOk&&budgetOk,fi:FEATURED.indexOf(code)};
  });
  scored.sort(function(a,b){return b.score-a.score || a.fi-b.fi;});
  var top=scored.slice(0,3);
  var anyExact=top.some(function(t){return t.exact;});
  var picks=top.map(function(t){return t.code;});
  // Reasoned result cards (image + price + why + PDP CTA) from CMPDATA.models — not bare codes.
  var html=top.map(function(t,i){
    var m=(CMPDATA.models&&CMPDATA.models[t.code])||{name:'SOLE '+t.code,price:'',img:'',href:'#'};
    var why=[]; if(fans.goal)why.push(GOAL_LABEL[fans.goal]);
    if(fans.fold&&t.foldOk)why.push(fans.fold==='Foldable'?'folds away':'stays in place');
    if(fans.budget&&t.budgetOk)why.push('in your budget');
    return '<a class="fcard'+(i===0?' fcard--best':'')+'" href="'+m.href+'">'+
      (i===0?'<span class="fcard__badge">Best match</span>':'')+
      '<span class="fcard__media">'+(m.img?'<img src="'+m.img+'" alt="'+m.name+'" loading="lazy">':'<span class="fcard__noimg">SOLE</span>')+'</span>'+
      '<span class="fcard__info"><span class="fcard__name">'+m.name+'</span>'+
      (m.price?'<span class="fcard__price">'+m.price+'</span>':'')+
      (why.length?'<span class="fcard__why">'+why.join(' · ')+'</span>':'')+
      '<span class="fcard__cta">View '+t.code+' →</span></span></a>';
  }).join('');
  document.getElementById('fpicks').innerHTML=html;
  var fw=document.getElementById('fresultWhy');
  if(fw) fw.textContent=anyExact?'Based on your answers, these fit best:':'No exact match — your closest fits:';
  document.querySelectorAll('.dots i').forEach(function(d){d.classList.remove('on');});
  // also spotlight in the grid below; F80 & F85 stay a permanent floor
  var keepSet=new Set(picks.concat(['F80','F85']));
  _items().forEach(function(el){el.classList.toggle('dim', !keepSet.has(el.getAttribute('data-code')));});
  var rh=res.querySelector('h2'); if(rh){rh.setAttribute('tabindex','-1');rh.focus({preventScroll:true});}
  var why=document.getElementById('whyLine'); if(why){why.classList.add('on');
    why.innerHTML='<b>Spotlighted below:</b> '+picks.join(' · ')+' (best-sellers always shown). <a href="#" onclick="finderReset();return false;" style="color:var(--sole-accent-text);font-weight:700">Start over</a>';}
}
function finderReset(){fstep=0;fmax=0;fbusy=false;fans={goal:null,fold:null,budget:null};_items().forEach(function(el){el.classList.remove('dim');});
  document.querySelectorAll('.fopt').forEach(function(o){o.classList.remove('sel');});
  var res=document.getElementById('fresult');if(res)res.classList.remove('on');
  document.querySelectorAll('.fstep').forEach(function(s,i){s.classList.toggle('on',i===0);});
  document.querySelectorAll('.finder .dots i').forEach(function(d,i){d.classList.toggle('on',i===0);});
  var nx=document.getElementById('fnext');if(nx){nx.setAttribute('disabled','');nx.textContent='Next';}
  var why=document.getElementById('whyLine');if(why)why.classList.remove('on');}
function finderSkip(){smoothTo(document.getElementById('mainGrid'));}
/* compare (Concept C) */
/* ===== multi-select COMPARE: persistent thumbnail tray -> focused side-by-side dialog (Concept C) ===== */
var cmpSel=[];
function cmpHint(msg){ var h=document.getElementById('ctrayHint'); if(h) h.textContent=msg||''; }
function cmpToggle(box){
  if(box.checked){
    if(cmpSel.length>=3){ box.checked=false; cmpHint('Compare up to 3 at a time — remove one first.'); return; }
    if(cmpSel.indexOf(box.value)<0) cmpSel.push(box.value);
  } else cmpSel=cmpSel.filter(function(v){return v!==box.value;});
  renderTray();
}
function renderTray(){
  var tray=document.getElementById('ctray'); if(!tray)return;
  var chips=document.getElementById('ctrayChips'), go=document.getElementById('ctrayGo'), cnt=document.getElementById('ctrayCount');
  var on=cmpSel.length>=1; tray.classList.toggle('on',on); tray.setAttribute('aria-hidden', on?'false':'true');
  tray.inert = !on; // closed tray is only transform-hidden; inert keeps its controls out of the tab order (WCAG 4.1.2)
  document.body.style.paddingBottom = on ? '92px' : '';
  // the tray is fixed to the bottom; tell fixed UI (the chat launcher) to sit above it
  if (window.SoleSafeBottom) window.SoleSafeBottom.set('compare-tray', on ? tray.offsetHeight : 0);
  chips.innerHTML = cmpSel.map(function(code){ var m=CMPDATA.models[code]||{};
    var img=m.img?'<img src="'+m.img+'" alt="">':'';
    return '<span class="ctray-chip">'+img+'<b>'+code+'</b><button type="button" aria-label="Remove '+code+'" onclick="cmpRemove(\''+code+'\')">&times;</button></span>'; }).join('');
  if(cnt) cnt.textContent=cmpSel.length;
  if(cmpSel.length<2){ go.setAttribute('disabled',''); cmpHint('Pick '+(2-cmpSel.length)+' more to compare'); }
  else { go.removeAttribute('disabled'); cmpHint(''); }
}
function cmpRemove(code){
  cmpSel=cmpSel.filter(function(v){return v!==code;});
  var b=document.querySelector('.cmpbox[value="'+code+'"]'); if(b)b.checked=false;
  renderTray();
  var dl=document.getElementById('cdlg');
  if(dl && dl.classList.contains('on')){
    if(cmpSel.length>=2){ renderCompareDialog(); var c=document.getElementById('cdlgClose'); if(c) c.focus(); } // the removed .mx button was destroyed by the re-render — move focus to a stable control
    else closeCompareDialog();
  }
}
function cmpClear(){
  cmpSel.slice().forEach(function(code){ var b=document.querySelector('.cmpbox[value="'+code+'"]'); if(b)b.checked=false; });
  cmpSel=[]; renderTray(); closeCompareDialog();
}
function openCompareDialog(){
  if(cmpSel.length<2)return;
  renderCompareDialog();
  document.getElementById('cdlgOv').classList.add('on');
  var dl=document.getElementById('cdlg'); dl.classList.add('on'); dl.setAttribute('aria-hidden','false'); dl.inert=false;
  lockScroll();
  trapFocus(dl);
  // .cdlg is visibility:hidden until .on lands, and an element computing to visibility:hidden cannot take
  // focus — so this focus() was a silent no-op and the dialog opened with focus still on the card checkbox
  // behind it (WCAG 2.4.3, and 2.1.2 for a keyboard user who then had nothing to Escape from). Flushing
  // style is NOT enough: `visibility` is in the .cdlg transition list, and a transition's value at t=0 is
  // still the START value, so it reads `hidden` for one more frame. Waiting a frame is what actually works
  // — and it takes TWO frames, not one. Measured identically on real WebKit 393 and Chromium 1440:
  // visibility is 'hidden' at t=0, still 'hidden' after one rAF, and 'visible' (and focusable) only on
  // the second. One rAF looks right and silently does nothing. Removing `visibility` from the transition
  // would also fix it, but it is there on purpose — it holds the dialog in the a11y tree until the close
  // animation finishes, so dropping it would make the dialog vanish instantly on close.
  requestAnimationFrame(function(){ requestAnimationFrame(function(){
    var c=document.getElementById('cdlgClose'); if(c) c.focus();
  }); });
}
function closeCompareDialog(){
  var ov=document.getElementById('cdlgOv'); if(ov)ov.classList.remove('on');
  var dl=document.getElementById('cdlg'); if(dl){dl.classList.remove('on'); dl.setAttribute('aria-hidden','true'); dl.inert=true; releaseFocus(dl);}
  unlockScroll();
}
function renderCompareDialog(){
  var diffOnly=(document.getElementById('cdlgDiffOnly')||{}).checked;
  var sel=cmpSel.slice(0,3);
  var head='<th scope="col" class="cdlg-corner"></th>'+sel.map(function(code){ var m=CMPDATA.models[code]||{};
    var best=m.best?' cdlg-col-best':''; var img=m.img?'<img src="'+m.img+'" alt="">':'';
    return '<th scope="col" class="'+best.trim()+'"><div class="cdlg-mhead">'
      +'<button class="mx" type="button" aria-label="Remove '+code+'" onclick="cmpRemove(\''+code+'\')">&times;</button>'
      +img+'<span class="mname">'+code+'</span><span class="mprice">'+(m.price||'')+'</span>'
      +'<a class="mview" href="'+(m.href||'#')+'">View '+code+' &rarr;</a></div></th>'; }).join('');
  var rows=CMPDATA.rows.map(function(r){ var label=r[0], vals=r[1];
    var cells=sel.map(function(code){ return (vals[code]!=null)?vals[code]:'—'; });
    var allEqual=cells.every(function(v){return v===cells[0];});
    if(diffOnly && allEqual) return '';
    return '<tr'+(allEqual?'':' class="diff"')+'><th scope="row">'+label+'</th>'+cells.map(function(v){return '<td>'+v+'</td>';}).join('')+'</tr>'; }).join('');
  document.getElementById('cdlgBody').innerHTML='<table class="cdlg-tbl"><thead><tr>'+head+'</tr></thead><tbody>'+rows+'</tbody></table>';
  document.getElementById('cdlgHead').textContent='Compare '+sel.join(' vs ');
}
/* ---- compare-on-demand (Concept C): matrix collapsed until requested ---- */
function revealCompare(){ var w=document.getElementById('compareWrap'); if(w&&w.hidden){ w.hidden=false; var b=document.getElementById('cmpToggleBtn'); if(b)b.setAttribute('aria-expanded','true'); } }
function toggleCompare(forceOpen){
  var w=document.getElementById('compareWrap'); if(!w)return;
  var open = (forceOpen===true) ? true : w.hidden;
  w.hidden = !open;
  // sync every control that toggles this region (header button + in-module toggle)
  var ctrls=document.querySelectorAll('#cmpToggleBtn,[aria-controls="compareWrap"]');
  ctrls.forEach(function(b){ b.setAttribute('aria-expanded', open?'true':'false'); });
  if(open) smoothTo(document.getElementById('compare'));
}
/* The old bestseller "confirm add-to-cart" drawer (openAddDrawer/closeDrawer + #drawer + the DRAWER map) was removed:
   the card "+ Add to cart" now submits a real /cart/add form and sole-cart-ajax.js opens the shipped cart drawer,
   which renders the correct line image/name/price via the Section Rendering API (no fragile per-code JS map). */
// Esc closes ONLY the surface that is actually open — calling the close fns unconditionally would run
// unlockScroll()->scrollTo() on every Esc and jump a scrolled page to the top.
document.addEventListener('keydown', function(e){
  if(e.key!=='Escape')return;
  var dl=document.getElementById('cdlg');
  if(dl && dl.classList.contains('on')){ closeCompareDialog(); return; }
});
/* Focus management for the modal surfaces (drawer + compare dialog): remember the opener, keep Tab inside
   the open surface, and return focus on close (WCAG 2.4.3 / 2.1.2). */
var _opener=null;
function _focusable(c){ return Array.prototype.slice.call(c.querySelectorAll(
  'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'
)).filter(function(el){ return el.offsetWidth>0||el.offsetHeight>0||el===document.activeElement; }); }
function trapFocus(c){ if(!c)return; _opener=document.activeElement;
  c.__trap=function(e){ if(e.key!=='Tab')return; var f=_focusable(c); if(!f.length)return;
    var first=f[0], last=f[f.length-1];
    if(e.shiftKey){ if(document.activeElement===first){ last.focus(); e.preventDefault(); } }
    else { if(document.activeElement===last){ first.focus(); e.preventDefault(); } } };
  c.addEventListener('keydown', c.__trap); }
function releaseFocus(c){ if(c&&c.__trap){ c.removeEventListener('keydown', c.__trap); c.__trap=null; }
  if(_opener&&_opener.focus){ try{ _opener.focus(); }catch(e){} } _opener=null; }
/* Safari-safe scroll lock: overflow:hidden on <body> makes Safari jump to top, so pin with position:fixed
   and restore the exact scroll position on close. */
var _scrollY=0;
function lockScroll(){ _scrollY=window.scrollY||window.pageYOffset||0; var b=document.body; b.style.position='fixed'; b.style.top=(-_scrollY)+'px'; b.style.left='0'; b.style.right='0'; b.style.width='100%'; }
function unlockScroll(){ var b=document.body; b.style.position=''; b.style.top=''; b.style.left=''; b.style.right=''; b.style.width=''; window.scrollTo(0,_scrollY); }
/* mockup: placeholder links point at "#" (PDPs aren't built) — stop them jumping to the top of the page */
document.addEventListener('click', function(e){ var a=e.target.closest&&e.target.closest('a[href="#"]'); if(a) e.preventDefault(); });
/* init: ensure finder option buttons expose aria-pressed for screen readers */
document.querySelectorAll('.fopt').forEach(function(o){ if(!o.hasAttribute('aria-pressed')) o.setAttribute('aria-pressed','false'); });
/* init: closed modal surfaces start inert so their controls aren't reachable while transform-hidden (WCAG 4.1.2) */
['cdlg','ctray'].forEach(function(id){ var el=document.getElementById(id); if(el) el.inert=true; });
/* --header-height (used by .ustrip's top) is published by sections/header.liquid, which is the single
   owner. A duplicate writer lived here: it set the var on document.body, which is a nearer ancestor than
   the <html> element the header writes to, so it WON the cascade on collection pages and masked the
   header's own value. It also measured the .shopify-section wrapper rather than the header, and drove
   itself from a scroll listener plus a ResizeObserver watching the element whose height was animating.
   Removed 2026-07-29 with the header-shake fix; see that section's INVARIANT comment. */
